import { QueryKeys } from "@/network/queryKeys";
import { TasksAPI } from "@/api/tasks";
import { useQuery } from "react-query";

export const useTaskPhotosQuery = ({ enabled, taskId, select }) => {
  return useQuery(
    [QueryKeys.bizTaskPhotos, taskId],
    () => TasksAPI.getPhotos(taskId).then(({ data }) => data),
    {
      enabled,
      select,
    }
  );
};
